import Header from "../../../../../components/common/header";

const BossGuideHowToUse = () => {
  return (
    <div className="flex flex-col min-h-screen h-full bg-white">
      <Header title="가이드" showBackButton />

      <div className="flex justify-center p-4 h-full">
        <iframe
          src="https://www.youtube.com/embed/a6b-W2XkX4g"
          title="마감히어로 사용 방법 (사장님편)"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          className="w-full h-full aspect-[9/16]"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default BossGuideHowToUse;
